import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import cross from "../Assets/cross.png";
import img1 from "../Assets/Group 1000002189.png";
import {
  addToCart,
  removeFromCart,
  getCartByUser,
  updateCartQuantity
} from "../Common/apis";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader.jsx";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../Components/Navbar2.jsx";
import Footer2 from "../Components/Footer2.jsx";
import Aos from "aos";

function Cart2() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("GISUL_TOKEN");

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      const response = await getCartByUser();
      setCart(response?.data?.courses || []);
    } catch (error) {
      console.error("Error fetching cart:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleIncrease = async (courseId, currentQuantity) => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      await updateCartQuantity({ courseId, quantity: currentQuantity + 1 });
      fetchCart();
    } catch (error) {
      console.error("Error updating cart quantity:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDecrease = async (courseId, currentQuantity) => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    if (currentQuantity > 1) {
      setLoading(true);
      try {
        await updateCartQuantity({ courseId, quantity: currentQuantity - 1 });
        fetchCart();
      } catch (error) {
        console.error("Error updating cart quantity:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleRemove = async (courseId) => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      await removeFromCart({ courseId });
      fetchCart();
    } catch (error) {
      console.error("Error removing from cart:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`new-home ${cart.length === 0 ? "h-[100vh]" : "h-auto"}`}>
      <Navbar2 />
      {/* <Navbar2 /> */}
      {loading ? <Loader /> : null}
      <div data-aos="flip-up" className="new-home-center new-home-center2">
        <h2 style={{ fontFamily: "DM sans, serif" }} className="font-[400] md:text-left text-center sm:text-[40px] text-[26px] md:leading-[46px] leading-[32px] text-[#FFFFFF]">Your cart Page</h2>
        <p>({cart.length || 0} Items)</p>
      </div>

      <div data-aos="flip-up" className="cart-div">
        {cart.length === 0 ? (
          <>
            <p style={{ fontFamily: "DM sans, serif" }} className="font-[400] md:text-left text-center sm:text-[20px] text-[16px] leading-[26px] text-[#FFFFFF] px-[30px]">Your cart is empty.</p>
            {cart?.length === 0 &&
              <div className="pb-[250px]"></div>
            }
          </>
        ) : (
          cart.map((item) => (
            <div className="w-full">
              {/* this is desktop view  */}
              <div className="md:flex hidden w-full">
                <div className="cart-section" key={item.course._id}>
                  <div className="flex w-full items-center gap-[24px]">
                    <div style={{ background: "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)" }} className="rounded-[12px] lg:py-[22px] py-[10px] lg:px-[22px] px-[10px] overflow-hidden">
                      <img
                        data-aos="fade-right"
                        className="cart-img"
                        src={
                          (item?.course?.images?.length > 0 &&
                            item?.course?.images[0]) ||
                          img1}
                        alt={item.course.name}
                        style={{}}
                      />
                    </div>
                    <div data-aos="fade-left" className="flex flex-col gap-[16px]">
                      <h3>{item.course.name}</h3>
                      <p>${item.course.price}</p>
                    </div>
                  </div>
                  <div data-aos="fade-right">
                    <h3 style={{ textAlign: "center" }}>Quantity</h3>
                    <div className="Quantity">
                      <button
                        onClick={() =>
                          handleDecrease(item.course._id, item.quantity)
                        }
                        style={{ color: "black" }}
                      >
                        -
                      </button>
                      <input
                        type="number"
                        value={item.quantity}
                        readOnly
                        style={{ color: "black" }}
                      />
                      <button
                        onClick={() =>
                          handleIncrease(item.course._id, item.quantity)
                        }
                        style={{ color: "black" }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="remover-btn-div">
                    <img
                      data-aos="fade-left"
                      src={cross}
                      alt="Remove"
                      onClick={() => handleRemove(item.course._id)}
                      style={{ cursor: "pointer" }}
                      className="remove-btn"
                    />
                  </div>
                </div>
              </div>
              {/* this is mobile view  */}
              <div className="md:hidden flex w-full">
                <div className="cart-section" key={item.course._id}>
                  <div className="flex items-center md:gap-[24px] gap-[12px]">
                    <div style={{ background: "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)" }} className="rounded-[12px] py-[22px] px-[22px] overflow-hidden">
                      <img
                        className="cart-img"
                        data-aos="fade-right"
                        src={
                          (item?.course?.images?.length > 0 &&
                            item?.course?.images[0]) ||
                          img1}
                        alt={item.course.name}
                        style={{}}
                      />
                    </div>
                    <div className="flex flex-col items-start gap-[1px]">
                      <h3 data-aos="fade-left">{item.course.name}</h3>
                      <p data-aos="fade-right">${item.course.price}</p>
                      <h3 data-aos="fade-left" style={{ textAlign: "center" }}>Quantity</h3>
                      <div data-aos="fade-right" className="Quantity">
                        <button
                          onClick={() =>
                            handleDecrease(item.course._id, item.quantity)
                          }
                          style={{ color: "black" }}
                        >
                          -
                        </button>
                        <input
                          type="number"
                          value={item.quantity}
                          readOnly
                          style={{ color: "black" }}
                        />
                        <button
                          onClick={() =>
                            handleIncrease(item.course._id, item.quantity)
                          }
                          style={{ color: "black" }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <img
                      data-aos="fade-left"
                      src={cross}
                      alt="Remove"
                      onClick={() => handleRemove(item.course._id)}
                      style={{ cursor: "pointer" }}
                      className="h-[34px] w-[34px] mr-[16px]"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
        {/* <div className="cart-section">
          <img src={img} />
          <div>
            <h3>AWS Skill Builder</h3>
            <p>$99.25</p>
          </div>
          <div>
            <h3 style={{ textAlign: "center" }}>Quantity</h3>
            <div className="Quantity">
              <button
                className=""
                onClick={handleDecrease}
                style={{ color: "black" }}
              >
                -
              </button>
              <input
                type="number"
                className=""
                value={quantity}
                onChange={handleChange}
                min="1"
                style={{ color: "black" }}
              />
              <button
                className=""
                onClick={handleIncrease}
                style={{ color: "black" }}
              >
                +
              </button>
            </div>
          </div>
          <div>
            <img src={cross} />
          </div>
        </div> */}

        {cart.length > 0 && (
          <div style={{ textAlign: "center", marginTop: "20px", background: "#6953A3B2" }} className="max-w-[1220px] md:mb-[77px] mb-[120px] w-full mx-auto rounded-[16px] p-[30px]">
            <h6 data-aos="fade-right" className="font-sans font-[400] text-[40px] leading-[44px] tracking-[-0.32px] pb-[22px] text-[#FFFFFF] text-left">Cart Total</h6>
            <div className="flex justify-between items-center pb-[22px]">
              <p data-aos="fade-right" className="font-[400] font-sans text-[20px] text-[#FFFFFF]">Subtotal</p>
              <h6 data-aos="fade-right" className="font-[700] font-sans text-[20px] text-[#FFFFFF]">$99.25</h6>
            </div>
            <div data-aos="fade-left" className="flex justify-between items-center pb-[16px]">
              <p className="font-[400] font-sans text-[20px] text-[#FFFFFF]">Total</p>
              <h6 className="font-[700] font-sans text-[20px] text-[#FFFFFF]">$99.25</h6>
            </div>
            <button
              data-aos="flip-up"
              onClick={() => navigate("/checkout")}
              className="font-sans max-w-[332px] w-full mx-auto"
              style={{
                backgroundColor: "#F1E60D",
                color: "#263238",
                padding: "10px 20px",
                fontSize: "16px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer"
              }}
            >
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>
      <Footer2 />
    </div>
  );
}

export default Cart2;
